import * as React from 'react'
import { connect } from 'react-redux'

import { MultiProductState } from 'embed/reducers'
import { ConfigKeys, DepositsFlow, DepositsStep } from 'even-ts-static'
import { DepositsView } from './index'
import { uiSelectedDepositsStepSelector } from 'embed/selectors/ui'

interface StoreProps {
  depositsFlow?: DepositsFlow
  selectedStep: DepositsStep
}

type Props = StoreProps

const DepositsContainer: React.FC<Props> = (props: Props) => <DepositsView {...props} />

const mapStateToProps = (state: MultiProductState): StoreProps => ({
  depositsFlow: state.config[ConfigKeys.DepositsFlow],
  selectedStep: uiSelectedDepositsStepSelector(state),
})

export const Deposits = connect(mapStateToProps)(DepositsContainer)
